// shared/lib/event-bus.ts
import mitt from "mitt"
import { IApiImageUploadResponse } from "../types"

export type AppEvents = {
    friendSendRequest: void
    friendRequestAccepted: void
    friendRequestDeclined: void
    friendRemoved: void
    notificationMarkedAsRead: void
    imageViewerOpen: string
    imageUploadStarted: void
    checkinImageUploaded: IApiImageUploadResponse
    avatarImageUploaded: IApiImageUploadResponse
};

export const eventBus = mitt<AppEvents>()
